<template>
    <div class="all">
      <Head></Head>
      <div class="details">
<!--        左边图片放大-->
        <div class="details_left">
          <div class="details_left_img">
<!--            <img src="../assets/service_items_2.jpg" alt="">-->
            <PicZoom :previewImg="smallImg" :zoomImg="bigImg"></PicZoom>
          </div>
          <div class="details_left_imgArr">
            <!--<div class="details_left_imgArr_img">
              <img :src="$store.state.Url+item.img_url" alt="" v-for="(item,key) in arrimg" @click="getUrlImg($store.state.Url+item.img_url)" :key="key">
              <div class="clear"></div>
            </div>-->
            <swiper :options="swiperOption1">
              <swiper-slide v-for="(item,key) in arrimg" :key="key">
                <img :src="$store.state.Url+item.img_url" alt class="all_characteristic_cen_img" @click="getUrlImg($store.state.Url+item.img_url)"/>
              </swiper-slide>
              <div class="swiper-button-prev left_class" slot="button-prev"></div>
              <div class="swiper-button-next right_class" slot="button-next"></div>
              <div class="swiper-pagination can" slot="pagination"></div>
            </swiper>
          </div>
          <div class="details_left_bon">
            <span v-if="ShopDateils.goods.code">商品编号：{{ShopDateils.goods.code}}</span>
            <span v-if="ShopDateils.collection_type==0" @click="getShoucang(0)">
              <img src="../assets/weishoucang.png" alt="">
              收藏商品
            </span>
            <span v-if="ShopDateils.collection_type==1" @click="getShoucang(1)">
              <img src="../assets/yishoucang.png" alt="">
              收藏商品
            </span>
          </div>
        </div>
<!--        右边详情-->
        <div class="details_right">
          <div class="details_right_title">
            <p>{{ShopDateils.goods.name}}</p>
          </div>
          <div class="details_right_beizhu">
            <p>{{ShopDateils.goods.inte_title}}</p>
          </div>
          <div class="details_right_price">
            <p>
              积分：<span>{{ShopDateils.goods.gral_price}}</span>
            </p>
          </div>
          <div class="details_right_code">
<!--            <span>商品编号：{{ShopDateils.goods.code}}</span>-->
            <span v-if="ShopDateils.goods.brand_name">商品品牌：{{ShopDateils.goods.brand_name}}</span>
            <p>
              <span>库存：{{ShopDateils.goods.tory}}</span>
              <!--推荐度：
              <img src="../assets/xingxing.png" alt="">
              <img src="../assets/xingxing.png" alt="">
              <img src="../assets/xingxing.png" alt="">-->
            </p>
          </div>
          <div class="details_right_code">
<!--            <span>赠送积分：{{ShopDateils.goods.inte_price || 0}}</span>-->
          </div>
          <div style="border-bottom: 1px solid #d1d1d1; margin: 20px 0"></div>
          <div class="details_right_dan1" v-if="ShopDateils.goods.goods_color.length>0">
            颜色：
            <p v-for="(item,key) in ShopDateils.goods.goods_color"
               :key="key"
               @click="getColor(item.id)"
               :class="item.id == colorId?'ColorId':''"
            >
              <img :src="$store.state.Url+item.img" alt="" style="width: 30px;height: 30px;vertical-align: middle" v-if="item.img">
              {{item.name}}
              <img src="../assets/xuanzhong.png" alt="" v-if="item.id == colorId" class="imgpos">
            </p>
          </div>
          <div class="details_right_dan">
            单位：
            <span>{{ShopDateils.goods.unit?ShopDateils.goods.unit:'个'}}
            <img src="../assets/xuanzhong.png" alt="">
            </span>
            <p>满百送货全北京</p>
          </div>
          <div class="details_right_dan">
            配送至：
            <el-select v-model="cityId" placeholder="请选择">
              <el-option
                v-for="item in ShopDateils.city"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </div>
          <div class="details_right_shop" style="display: none">
            <span>购买数量：</span>
            <p>
              <el-input-number v-model="num" @change="handleChange" :min="1" :max="ShopDateils.goods.tory" label="描述文字"></el-input-number>
            </p>
<!--            <span>销售：30</span>-->
          </div>
          <div class="details_right_butt">
            <button @click="getShopingjifen">立即兑换</button>
           <!-- <button v-if="ShopDateils.collection_type==0" @click="getShoucang(0)">收藏商品</button>
            <button v-if="ShopDateils.collection_type==1" @click="getShoucang(1)">取消收藏商品</button>-->
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="details_text">
        <div class="details_text_left">
          <p class="details_text_left_title">
            <span></span>
            销量排行
          </p>
          <div class="details_text_left_for" v-for="(val,index) in conder" :key="index" @click="ini1t(val.id)">
            <img :src="$store.state.Url+val.goods_img" alt="">
            <span>￥{{val.price}}</span>
            <p>{{val.name}}</p>
          </div>
        </div>
        <div class="details_text_right">
          <div class="details_text_right_tab">
            <ul>
              <li @click="getClick(1)" :class="tab == 1?'aevie':'parameter-box'">商品简介</li>
              <li @click="getClick(2)" :class="tab == 2?'aevie':'parameter-box'">规格参数</li>
<!--              <li @click="getClick(3)" :class="tab == 3?'aevie':'parameter-box'">商品评论</li>-->
              <li @click="getClick(4)" :class="tab == 4?'aevie':'parameter-box'">售后服务</li>
              <div class="clear"></div>
            </ul>
          </div>
          <div class="details_text_right_t" v-if="tab==1">
<!--            <div class="details_text_right_t_img">
              <img :src="$store.state.Url+ShopDateils.goods.goods_img" alt="">
            </div>
            <div class="details_text_right_t_g">
              <p>商品编号: {{ShopDateils.goods.code}}</p>
              <p>品       牌：{{ShopDateils.goods.brand_name}}</p>
              <p>商品全称：{{ShopDateils.goods.name}}</p>
&lt;!&ndash;              <p>商品描述：彩色双面复印，彩色双面打印 双纸盒，网络 彩色扫描，每分钟40页</p>&ndash;&gt;
            </div>-->
            <div class="details_text_right_t_S">
<!--              <p>商品描述：</p>-->
<!--              <img src="../assets/cpzs.jpg" alt="" style="width: 100%">-->
              <div class="fuwenben" v-html="fuwenben">

              </div>
            </div>
          </div>
          <div class="details_text_right_t" v-if="tab==2">
            <div class="details_text_right_t_g">
              <p>商品编号: {{ShopDateils.goods.code}}</p>
              <p>品       牌：{{ShopDateils.goods.brand_name}}</p>
              <p>商品全称：{{ShopDateils.goods.name}}</p>
            </div>
          </div>
          <div class="details_text_right_t" v-if="tab==3">
            <div class="details_text_right_t_Ping">
              <span @click="getComment('')">全部({{ShopDateils.comment_count}})</span>
              <span @click="getComment(1)">好评({{ShopDateils.hot_ment}})</span>
              <span @click="getComment(2)">中评({{ShopDateils.int_ment}})</span>
              <span @click="getComment(3)">差评({{ShopDateils.bad_ment}})</span>
            </div>
            <div class="details_text_right_t_text" v-for="(item,index) in PinLun" :key="index">
              <div class="details_text_right_t_text_for">
                <div class="details_text_right_t_text_for_left">
                  <img :src="$store.state.Url+item.user_img" alt="">
                  <p>{{item.user_name}}</p>
                </div>
                <div class="details_text_right_t_text_for_right">
                  <p>{{item.name}}</p>
                  <div class="details_text_right_t_text_for_right_xing">
                    <span>{{item.add_time}}</span>
                    <div>
                      推荐度：
                      <img src="../assets/xingxing.png" alt="" v-for="i in Number(item.xing)">
                    </div>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </div>
          <div class="details_text_right_t" v-if="tab==4">
            <div class="details_text_right_t_S">
              <p>付款方式</p>
              <img src="../assets/liucheng.png" alt="" style="width: 100%">
              <p>正品行货 联保服务</p>
              1.全友云商向您保证所售商品均为正品行货，所有商品均由各大品牌厂商直接供货，统一采购，集中入仓，全友设有相应的规范监控机制，可开机打发票。可享受全国联保服务，与您亲临商场选购的商品享受相同的质量保证。
              <br/>2.注：因厂家会在没有任何提前通知的情况下更改产品包装、产地或者一些附件，本公司不能确保客户收到的货物与商城图片、产地、附件说明完全一致。但能确保为原厂正货！并且保证与当时市场上同样主流新品一致。若本商城没有及时更新，请大家谅解！
              <p>无忧商品退换流程</p>
              1.您希望退换产品，请收到产品后在15日内提出退货要求，我们将根据实际情况和您协商退换货事宜。
              <br/>2.物流将商品送达时，请您注意清点商品以及检查性能。如商品质量有问题，请当即交于物流带回，物流回单上减去其商品。
              <br/>3.办公耗材类：如送达的商品外包装已经被打开，请您拒收商品。产品使用中出现故障后，将送达相应厂商指定的检测中心进行检验，依据检测中心出具的相关《产品检测报告》确定解决方案，检测中心的《产品检测报告》是我们确定更换的唯一标准。
              <br/>4.办公设备 IT数码类：
              <br/>a.您订购的产品需要安装和调试服务，我们将提供上门服务。
              <br/>b.产品在保修期内出现故障，我们将按厂商售后服务标准执行。
              <br/>c.产品在保修期外出现故障，我们将提供增值服务协助您解决问题。
              <br/>d.我们将帮助您轻松解决办公设备、IT数码类产品使用遇到的问题，详情请联系客户服务热线电话400-700-2248转人工。
              <br/>e.退款时间：全友云商确定退货原因后正式受理退货手续开始7个工作日之内。
              <p>不可退换商品类</p>
              1.客户不能提供原始购物凭证的，不可退换货。
              <br/>2.在商品本身未存在性能故障情况下，因客户责任造成商品外观损坏、内外包装不全或破损、配件不全或损坏及商品使用性能损坏的货品，则不享受退换货服务。
              <br/>3.应客户的要求、特别定制的商品，如直送定单、代客户采购等商品，无质量问题不可退换货。
              <br/>4.手机、数码、通讯、IT、摄影和办公设备类产品按国家三包规定执行，无质量问题不可退换货。
              <br/>a.食品类商品不能进行退换货。
              <br/>b.定制办公家具类商品不能进行退换货。
              <br/>c.促销活动的赠品不能进行退换货。
              <br/>d.特价清仓商品不能进行退换货。
              <br/>e.合同签定有相应条款的按合同条款执行。
              <p>退换货</p>
              1.退换货条件
              商品交付15日之内，出现下列情形之一的可以申请退换货
              <br/>a.商品有质量问题（发现可能是质量问题时请立即停止使用并联系全友云商客服人员）。
              <br/>b.法律规定的可退换货的情形（双方事先特别约定的不可退换货的商品除外）。
              <br/>2.操作步骤
              <img src="../assets/shouhou.png" alt="" style="width: 100%">
              <p>权利声明</p>
              注：本站商品信息均来自于合作方，其真实性、准确性和合法性由信息拥有者（合作方）负责。本站不提供任何保证，并不承担任何法律责任。
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import PicZoom from '../assembly/PicZoom'
  import img from '../assets/service_items_2.jpg'
  import {getDateils,getComment_Pinglun,getshopping,getaddcollection,getquxiaocollection,getgoodsdateils} from "../api/List";
  import {getsduihuan} from "../api/Mycen";
    export default {
        name: "details",
        data(){
          return{
            swiperOption1: {
              slidesPerView: 4,
              spaceBetween: 30,
              loop: true,
              pagination: {
                // el: '.can',
              },
              navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
              }
            },
            tab:1,
            num: 1,
            name: 1,
            smallImg:img,  //展示中的图片
            bigImg:img, //放大后的图片
           /* arrimg:[   // 下面可供选择的图片
              {
                img:img1,
              },
              {
                img:img3,
              },
            ],*/
            arrimg:[],
            conder:[],
            PinLun:[],
            ShopDateils:{
              goods:{
                goods_color:[]
              },
              conder:[],
            },
            colorId:"",
            fuwenben:"",
            cityId:'110101',
          }
        },
      mounted() {
        window.scrollBy(0,-10);
        // console.log(this.$store.state.user.uesr.id)
          this.init()
          this.getComment('')
      },
      components:{
          Pagetail,Head,PicZoom
        },
        methods:{
          getColor(id){
            this.colorId = id
          },
          getShoucang(e){
            if (this.$store.state.user.token){
              if (e == 0){
                //  Foc/add_collection  添加收藏,goods_id,status
                getaddcollection({
                  goods_id:this.$route.query.id,//
                  status:this.$route.query.status,//
                }).then(res=>{
                  this.init()
                })
              }else {
                // quxiao_collection 取消收藏, goods_id,status
                getquxiaocollection({
                  goods_id:this.$route.query.id,//
                  status:this.$route.query.status,//
                }).then(res=>{
                  this.init()
                })
              }
            }else {
              this.$message('请登录');
            }
          },
          getShoping(){
            if (this.$store.state.user.token){
              getshopping({
                goods_id:this.$route.query.id,
                goods_color_id:this.colorId,
                num:this.num
              }).then(res=>{

              })
            }else {
              this.$message('请登录');
            }
          },
          getShopingjifen(){
            if (this.$store.state.user.token){
              this.$confirm('是否兑换此商品, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                getsduihuan({
                  id:this.$route.query.id
                }).then(res=>{

                })
              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
              });
            }else {
              this.$message('请登录');
            }
          },
          getComment(e){
            getComment_Pinglun({
              type:e
            }).then(res => {
              this.PinLun = res.comments
            })
          },
          init(){
            getgoodsdateils({
              id:this.$route.query.goodsid,//
              gral_id:this.$route.query.id,//
              // user_id:this.$store.state.user.uesr.id, //
            }).then(res => {
              this.ShopDateils = res
              this.fuwenben = res.goods.goods_desc.replace(/\n/g,"<br/>")
              this.fuwenben = this.fuwenben.replace('&nbsp;'," ")
              console.log(this.fuwenben)
              this.arrimg = res.goods.photo
              this.bigImg = this.$store.state.Url+res.goods.photo[0].img_url
              this.smallImg = this.$store.state.Url+res.goods.photo[0].img_url
              this.conder = res.conder
              // console.log(res.goods.photo)
            })
          },
          ini1t(id){
            this.$router.push({path:'/details',query:{id:id,status:2}})
            /*getDateils({
              id:id,//
              status:this.$route.query.status,//
              // user_id:this.$store.state.user.uesr.id, //
            }).then(res => {
              this.ShopDateils = res
              this.fuwenben = res.goods.goods_desc.replace(/\n/g,"<br/>")
              this.fuwenben = this.fuwenben.replace('&nbsp;'," ")
              console.log(this.fuwenben)
              this.arrimg = res.goods.photo
              this.bigImg = this.$store.state.Url+res.goods.photo[0].img_url
              this.smallImg = this.$store.state.Url+res.goods.photo[0].img_url
              this.conder = res.conder
              window.scrollTo(0, 0);
              // console.log(res.goods.photo)
            })*/
          },
          handleChange(value) {
            // console.log(value);
          },
          getClick(e){
            this.tab = e
          },
          getUrlImg(img){
            this.smallImg = img
            this.bigImg = img
          }
        }
    }
</script>

<style scoped lang="less">
  @import "css/details";
  .fuwenben{
    width: 950px;
    /deep/ img{
      width: 100%;
      height: 100%;
    }
  }
</style>
<style>
  .right_class{
    width: 45px;
    height: 45px;
    background: url("../assets/youhuadong.png") no-repeat!important;
    background-size: 100% 100%!important;
  }
  .left_class{
    width: 45px;
    height: 45px;
    background: url("../assets/zuohuadong.png") no-repeat!important;
    background-size: 100% 100%!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/detailsjifen.vue